import { useCallback, useRef } from 'react';
import { setToken as setAllowerToken } from '@ion/api/Apollo/allower';

/**
 * Hook to manage the session token in a ref.
 * Centralizes token storage, prevent unnecessary re-renders on refresh, and ensures permissions are updated.
 *
 * @returns {Object} - { getToken, setToken }
 */
export const useToken = () => {
  const tokenRef = useRef(null);

  const setToken = useCallback(token => {
    tokenRef.current = token;
    // Update allower module for permissions (role-based access)
    setAllowerToken(token);
  }, []);

  const getToken = useCallback(() => {
    return tokenRef.current;
  }, []);

  return { getToken, setToken };
};
